var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/branches/index.vue?vue&type=template&id=101f4761&scoped=true
// module id = qBJE
// module chunks = 0